import type { Condition } from '@medplum/fhirtypes'
import {
  CONDITION_CATEGORIES,
  ConditionCategory,
} from '#src/models/conditions/constants.ts'
import {
  ExtendedCondition,
  type ExtendedConditionSearchQueryOptions,
} from '#src/models/conditions/ExtendedCondition.ts'
import type { QueryTypes } from '#src/search.ts'

export class CarePlanProblem extends ExtendedCondition {
  static isInstance(resource: ExtendedCondition): resource is CarePlanProblem {
    return resource.category === ConditionCategory.CARE_PLAN_PROBLEM
  }

  static searchQuery(options: ExtendedConditionSearchQueryOptions): QueryTypes {
    return {
      ...ExtendedCondition.searchQuery(options),
      category: CONDITION_CATEGORIES[ConditionCategory.CARE_PLAN_PROBLEM],
    }
  }

  constructor(params: Pick<Condition, 'subject' | 'recorder'>) {
    super({
      category: ConditionCategory.CARE_PLAN_PROBLEM,
      ...params,
    })
  }
}
